
import { memo } from 'react';
import { Link } from 'react-router-dom';
import { useHomePageData } from '../../content/useSiteContent';
import QuoteStudio from './QuoteStudio';
import './HeroSection.css';

const HeroSection = ({
  variant = 'home',
  caseStudiesHeadline,
  caseStudiesDescription,
  caseStudiesCta,
  caseStudiesVisual,
}) => {
  const { hero } = useHomePageData();

  if (variant === 'case-studies') {
    return (
      <section
        className="hero-section hero-section--case-studies-page"
        aria-label="Case studies introduction"
        data-track-section="case-studies-hero"
      >
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-headline hero-headline--case-studies">{caseStudiesHeadline}</h1>
            <p className="hero-description">{caseStudiesDescription}</p>
            {caseStudiesCta}
          </div>
          <div className="hero-visual hero-visual--case-studies-static">{caseStudiesVisual}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="hero-section hero-section--globe-ready" data-track-section="home-hero">
      <div className="hero-ambient-glow" aria-hidden="true" />
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-headline">
          {hero.titleLine1}<br />
            <span className="headline-purple">
            {hero.titleAccent}
            </span>
            <br />
            {hero.titleLine2}<br />
            {hero.titleLine3}

          </h1>
          <p className="hero-description">
          {hero.description}
          </p>

          <Link className="hero-cta-contact" to={hero.ctaTo} aria-label="Contact us" data-track-cta="contact-us">
            {hero.ctaLabel}
          </Link>
        </div>

        <div className="hero-visual hero-visual--quote">
          <QuoteStudio />
        </div>
      </div>
    </section>
  );
};

export default memo(HeroSection);
